import React, { PropsWithChildren } from "react";
import classNames from "classnames";

const Overlay = React.forwardRef<HTMLDivElement, PropsWithChildren>(
  (props, ref) => {
    return (
      <div ref={ref} className={classNames("pubr-overlay")}>
        <div className="pubr-overlay__inner">{props.children}</div>
      </div>
    );
  }
);

export { Overlay };
